function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "var(--primary-color, #000)",
  strokeLinejoin: "round",
  strokeMiterlimit: 3.998
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.46 30.135c.023-.452.252-.907.252-1.365v0c0-13.832-10.465-25.044-23.375-25.044-12.909 0-23.375 11.213-23.375 25.044 0 .458.23.913.253 1.365-.732 2.175-1.233 4.35-1.46 6.525a29.315 29.315 0 01-1.073-7.89c0-15.18 11.486-27.487 25.655-27.487S53.992 13.59 53.992 28.77v0c0 2.743-.375 5.391-1.073 7.89-.178-2.276-.717-4.478-1.46-6.525z",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.918 52.592h-2.842l.073-27.293h2.986c.05 27.293-.083 27.293-.083 27.293 3.735 0 6.85-5.711 6.85-12.806v-1.68c0-7.095-3.115-12.807-6.984-12.807M10.759 52.592h2.842l-.073-27.293h-2.986c-.05 27.293.083 27.293.083 27.293-3.735 0-6.85-5.711-6.85-12.806v-1.68c0-7.095 3.115-12.807 6.984-12.807"
}));

var SvgHeadphones = function SvgHeadphones(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeadphones, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Headphones.3dc4d1c7.svg";
export { ForwardRef as ReactComponent };